<template>
  <div class="page-section">
    <h1 class="section-title">
      Free up <b>extra money</b>
    </h1>
    <p class="section-subtitle">
      If you implement these tips, you could potentially save an extra <b>£{{ numberToHumanReadable(totalSavings) }}</b> per month.
    </p>
    <div
      v-if="isDataMissing"
      class="connect-another-subtitle"
    >
      We don't have enough data to display your Saving tips.
      <b @click="handleConnectAccountsClick">connect an active account</b>
      to get the full picture.
    </div>
    <horizontal-scroll>
      <div
        v-for="(tip, index) in displayTips"
        :key="index"
        class="card"
        :class="{ 'disabled': isDataMissing }"
      >
        <div class="tip-number">
          {{ index + 1 }}
        </div>
        <div class="tip-text">
          {{ tip.text }}
        </div>
      </div>
    </horizontal-scroll>
    <div class="divider-line" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { numberToHumanReadable } from '../../../../utils/miscUtils';
import HorizontalScroll from '../../../Common/HorizontalScroll.vue';

const props = defineProps({
  tips: {
    type: Array,
    required: true,
  },
  totalSavings: {
    type: Number,
    required: true,
  },
  isDataMissing: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['connectAccountsClick']);

const displayTips = computed(() => {
  if (props.isDataMissing) {
    return [
      { text: 'Connect another account to get these saving tips' },
      { text: 'Connect another account to get these saving tips' },
    ];
  }

  return props.tips;
});

const handleConnectAccountsClick = () => {
  emit('connectAccountsClick');
};
</script>

<style scoped>
.page-section {
  color: white;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 20px;
}

.connect-another-subtitle {
  font-size: 14px;
  font-family: CircularStdBook;
  margin-bottom: 10px;
  margin-top: 10px;
  background-color: #FFDC73;
  color: #205441;
  text-align: center;
  padding: 20px;
  border-radius: 16px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  font-weight: 100 !important;
}

.connect-another-subtitle b {
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}

.section-title {
  font-size: 48px;
  font-weight: bold;
  font-family: CircularStd;
  line-height: 1;
  margin-top: 30px;
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.section-subtitle {
  font-size: 19px;
  font-family: CircularStdBook;
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: left;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.card {
  z-index: 1;
  flex: 0 0 300px;
  background-color: white;
  border-radius: 25px;
  padding: 28px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  min-height: 330px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.card.disabled {
  background-color: #F1F5FA !important;
  box-shadow: 0px 16px 46px rgba(22.80, 123.92, 42.57, 0.1) !important;
}

.card.disabled .tip-number,
.card.disabled .tip-text {
  color: #B0B0B0 !important;
}

.tip-number {
  width: 36px;
  height: 36px;
  background-color: #FFCE00;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
  color: #205441;
  margin-bottom: 20px;
}

.tip-text {
  font-size: 19px;
  color: #205441;
  line-height: 1.3;
  flex: 1;
  width: 100%;
  white-space: normal;
}

.divider-line {
  width: 90%;
  opacity: 0.5;
  margin: 0 auto;
  margin-top: 30px;
  height: 1px;
  background-color: white;
}
</style>
